import { env, ENV_DEV, DEV_DEBUG } from 'config/env';
import { randomBool } from 'utils/random';
import { doAfterTimeout } from 'utils/timeout';

import { get } from './index';

const DEBUG = env === ENV_DEV && DEV_DEBUG;

export const getFeatures = () => {
  const endpoint = `catalog/features`;
  return get(endpoint);
};

export const getPackages = () => {
  const endpoint = `catalog/feature_groups`;
  return get(endpoint);
};

export const getPackageUsers = ({ packageId, page, perPage }) => {
  const endpoint = `catalog/feature_groups/users`;
  if (!DEBUG)
    return get(endpoint, {
      name: packageId,
      per_page: perPage || 10,
      page: page || 0,
    });

  console.info('api.features.getPackagesUsers - ', endpoint); //eslint-disable-line no-console
  return doAfterTimeout(true, 500);
};

export const getFeatureUsers = ({ featureId, page, perPage }) => {
  const endpoint = `catalog/features/users`;
  if (!DEBUG)
    return get(endpoint, {
      name: featureId,
      per_page: perPage || 10,
      page: page || 0,
    });

  console.info('api.features.getFeatureUsers - ', endpoint); //eslint-disable-line no-console
  return doAfterTimeout(true, 500);
};
